import { Ifo } from './types'


const ifos: Ifo[] = [
 {
    id: 'flavors',
    address: '0x0000000000000000000000000000000000000000',
    isActive: true,
    name: 'Flavors BSC',
    subTitle: 'Scoop up access to a flavorful variety of vetted projects and exclusive presales! Earn rewards through every melty drip.',
    description: 'Flavors BSC is here for the community. Grab a taste out of what it means to get more from DeFi. Scoop up access to a flavorful variety of vetted projects and exclusive presales and earn rewards through every melty drip. Invest in something delicious.',
    launchDate: 'October 22nd',
    launchTime: '7PM PST',
    saleAmount: '60,000,000 FLV',
    raiseAmount: '600 BNB',
    cakeToBurn: '',
    projectSiteUrl: 'https://flavorsBSC.com',
    currency: '',
    currencyAddress: '0x0000000000000000000000000000000000000000',
    tokenDecimals: 9,
    tokenSymbol: 'FLV',
    releaseBlockNumber: 0,
    campaignId: '0',
  }, 
  {
    id: 'mooney',
    isActive: true,
    address: '0x98631c69602083d04f83934576a53e2a133d482f',
    //lpAddress: '0x4Bc16CbAaBdE5878Cf637429bA13AeaA669030DD',
    name: 'xMooney',
    tokenSymbol: 'xM',
    //logo: '../.../images/drips/xMooney.svg',
    subTitle: 'xMooney Decentralized Mining',
    description: 'The xMooney Mining Network is outward-focused, leveraging rewards from multiple cryptocurrencies such as Ethereum, Bitcoin, Monero, and Ravencoin  bringing value back to create resiliency and long-term sustainability in the project.',
    tokenDecimals: 9,
    projectSiteUrl: 'https://www.xmooneytoken.com/',
    //dripStartBlock: 12011339
    launchDate:'',
    launchTime:'',
    saleAmount:'',
    raiseAmount:'',
    cakeToBurn:'',
    currency:'',
    currencyAddress:'',
    releaseBlockNumber:0,
  },    
  {
    id: 'safeearn',
    isActive: true,
    address: '0x099f551eA3cb85707cAc6ac507cBc36C96eC64Ff',
    //lpAddress: '0xd9E38dD052BB997d3c983bf9B49D30fa133F7cF9',
    name: 'SafeEarn',
    tokenSymbol: 'SAFEEARN',
    //logo: '../.../images/drips/SafeEarn.svg',
    subTitle: 'Safely back to the Moon',
    description: 'SafeEarn is a risk-free passive income platform. Earn popular high-yield tokens seamlessly through staking. No risk, no effort.',
    tokenDecimals: 9,
    projectSiteUrl: 'https://www.safearn.money/',
    //dripStartBlock: 12011339
    launchDate:'',
    launchTime:'',
    saleAmount:'',
    raiseAmount:'',
    cakeToBurn:'',
    currency:'',
    currencyAddress:'',
    releaseBlockNumber:0,
    
  },
]

export default ifos
